export default __webpack_public_path__ + "e6b3675.png";